import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { getNonBankQuickAssessmentThunk } from './thunk'

const initialState = {
  loading: true,
  data: {},
}

const slice = createSlice({
  name: 'companyAnalysis/financialAnalysis/nonBank/quickAssessment',
  initialState: initialState,
  reducers: {
    resetStoreNonBankQuickAssessment: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getNonBankQuickAssessmentThunk.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      getNonBankQuickAssessmentThunk.fulfilled,
      (state, action) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(getNonBankQuickAssessmentThunk.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { resetStoreNonBankQuickAssessment } = slice.actions

export const selectLoading = (state) => state[slice.name].loading
export const selectData = (state) => state[slice.name].data

register(slice.name, slice.reducer)
